import { useState } from "react";
import ShareIcon from "@mui/icons-material/Share";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";

import { Button, Text } from "$components";

type Props = {
  hasLabel?: boolean;
  url?: string;
};

function ShippingRecordShareButton({ hasLabel = true, url }: Props) {
  const [isShareUrlDisplayed, toggleShareUrl] = useState<boolean>(false);
  const [isCopiedToClipboardMessageDisplayed, toggleCopiedToClipboardMessage] =
    useState<boolean>(false);

  const handleCopyToClipboard = async () => {
    await navigator.clipboard.writeText(url ?? window.location.href);
    toggleCopiedToClipboardMessage(true);
    setTimeout(() => {
      toggleCopiedToClipboardMessage(false);
    }, 3000);
  };

  if (!isShareUrlDisplayed) {
    return (
      <Button variant="outlined" onClick={() => toggleShareUrl(true)}>
        <ShareIcon style={{ marginRight: 8 }} />
        {hasLabel && "Partager"}
      </Button>
    );
  }
  return (
    <div>
      <Text type="link">{url ?? window.location.href}</Text>
      <Button
        color="primary"
        variant="text"
        style={{ minWidth: 50 }}
        onClick={handleCopyToClipboard}
      >
        <FileCopyOutlinedIcon />
      </Button>
      {isCopiedToClipboardMessageDisplayed && <Text>Copié!</Text>}
    </div>
  );
}

export default ShippingRecordShareButton;
